<uilab-app-bar
    #appbar
    appName="Design System"
    [userMenuOptions]="userMenuOptions"
    [searchOption]="searchOption"
    (menuItemSelected)="menuItemSelected($event)"
    [isLoggedIn]="isLoggedIn"
    [legal]="legal"
    class="uilab-app-bar"
    (toggleMobileNav)="toggleNav()"
>
</uilab-app-bar>
